/**
 * Add scopes here for ID token to be used at Microsoft identity platform endpoints.
 */
export const LoginRequest = {
  scopes: ["email", "openid", "profile"],
};
